// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Modal from './Modal';
import Loading from 'react-loading';
import { toast } from 'react-toastify';

import { getDisplayCardNumber, getCardImage } from '../../utilities/formatDisplay';
import { isValidPaymentMethod } from '../../utilities/paymentCheck';

export default class AddPaymentMethod extends Modal {

    state = {
        card: {
            number: "",
            expiry: "",
            cvc: ""
        },
        details: {
            address: {
                postal_code: "",
                country: "US"
            },
            email: "",
            name: ""
        },
        cardCheck: {
            number: true,
            expiry: true,
            cvc: true,
            zip: true,
            country: true,
            name: true
        },
        verifying: false
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">

            <h1>Add a new Payment Method</h1>

            <div className="form-group">

                <div className="form-line">
                    <label>Card Holder<span className="billing-required">*</span></label>
                    <div className="form-input-container">
                        <input
                            type="text"
                            autoFocus
                            className={!this.state.cardCheck.name ? "input-error" : ""} 
                            placeholder="Full Name"
                            autoComplete="off"
                            value={this.state.details.name}
                            onChange={(e) => this.setState({
                                details: {
                                    ...this.state.details,
                                    name: e.target.value
                                }
                            })}
                        />
                    </div>
                </div>

                <div className="form-line">
                    <label>Card Number<span className="billing-required">*</span></label>
                    <div className="form-input-container">
                        <input
                            ref="card"
                            className={!this.state.cardCheck.number ? "input-error" : ""} 
                            type="text"
                            placeholder="XXXX XXXX XXXX XXXX"
                            autoComplete="off"
                            maxLength="19"
                            value={getDisplayCardNumber(this.state.card.number)}
                            onChange={(e) => this.setState({
                                card: {
                                    ...this.state.card,
                                    number: e.target.value.replace(/\s/g, ''),
                                },
                                cardCheck: {
                                    ...this.state.cardCheck,
                                    number: true
                                }
                            })}
                        />

                        {this.state.cardCheck.number ? <div className="billing-input-logo">{getCardImage(this.state.card.number)}</div> : ""}
                    </div>
                </div>

                <div className="form-line">
                    <label>Expiry Date<span className="billing-required">*</span></label>

                    <div className="form-input-container" style={{ width: 150 }}>
                        <input
                            className={!this.state.cardCheck.expiry ? "input-error" : ""}
                            type="text"
                            placeholder="MM/YYYY"
                            autoComplete="off"
                            value={this.state.card.expiry}
                            onChange={(e) => {
                                let expiry = e.target.value;

                                // Erasing?
                                if (this.state.card.expiry.length === 3 && expiry.length === 2)
                                    return this.setState({ card: { ...this.state.card, expiry } });

                                if (expiry.length > 2) {
                                    if (expiry[2] !== "/")
                                        expiry = expiry.substr(0,2) + "/" + expiry.substr(2);
                                    if (isNaN(expiry.substr(0,2)) || isNaN(expiry.substr(3)))
                                        return;
                                }
                                else if (expiry.length === 2) expiry += "/";
                                else if (isNaN(expiry)) return;

                                this.setState({
                                    card: {
                                        ...this.state.card,
                                        expiry
                                    },
                                    cardCheck: {
                                        ...this.state.cardCheck,
                                        expiry: true
                                    }
                                });
                            }}
                        />
                    </div>

                    <label style={{
                        marginLeft: 40,
                        width: 60
                    }}>CVC<span className="billing-required">*</span></label>
                    
                    <div className="form-input-container" style={{ width: 110 }}>
                        <input
                            className={!this.state.cardCheck.cvc ? "input-error" : ""}
                            type="text"
                            placeholder="XXXX"
                            autoComplete="off"
                            value={this.state.card.cvc}
                            onChange={(e) => {
                                const cvc = e.target.value;
                                if (isNaN(cvc)) return;
                                this.setState({
                                    card: {
                                        ...this.state.card,
                                        cvc
                                    },
                                    cardCheck: {
                                        ...this.state.cardCheck,
                                        cvc: true
                                    }
                                });
                            }}
                        />
                    </div>
                </div>

                <div className="form-line">
                    <label>ZIP Code<span className="billing-required">*</span></label>
                    <div className="form-input-container" style={{ width: '160px' }}>
                        <input
                            type="text"
                            className={!this.state.cardCheck.zip ? "input-error" : ""}
                            placeholder="XXXXX"
                            autoComplete="off"
                            value={this.state.details.address.postal_code}
                            onChange={(e) => this.setState({
                                details: {
                                    ...this.state.details,
                                    address: {
                                        ...this.state.details.address,
                                        postal_code: e.target.value
                                    }
                                }
                            })}
                        />
                    </div>

                    <label style={{
                        marginLeft: '60px',
                        width: '80px'
                    }}>Country<span className="billing-required">*</span></label>
                    
                    <div className="form-input-container" style={{ width: '60px' }}>
                        <input
                            type="text"
                            className={!this.state.cardCheck.country ? "input-error" : ""}
                            placeholder="CO"
                            autoComplete="off"
                            value={this.state.details.address.country}
                            onChange={(e) => this.setState({
                                details: {
                                    ...this.state.details,
                                    address: {
                                        ...this.state.details.address,
                                        country: e.target.value
                                    }
                                }
                            })}
                        />
                    </div>
                </div>

                <div style={{ height: 0, clear: 'both' }} />

            </div>

            <div style={{ clear: 'both' }} />

            {this.state.verifying ? <div
                style={{
                    width: 80,
                    margin: "0 auto",
                    marginTop: -10
                }}
            >
                <Loading
                    type="bubbles"
                    color="var(--color-primary-dark)"
                    height={80}
                    width={80}
                />
            </div> : <div
                className="button"
                style={{
                    float: 'none',
                    backgroundImage: "url('https://static.stax.ai/images/icons/card.png')"
                }}
                onClick={async () => {
                    await this.setState({
                        cardCheck: {
                            number: true,
                            expiry: true,
                            cvc: true,
                            zip: true,
                            country: true,
                            name: true
                        },
                        verifying: true
                    });

                    const ok = isValidPaymentMethod(this.state.card, this.state.details.address.postal_code, this.state.details.address.country);

                    if (!this.state.details.name || this.state.details.name.length < 6) {
                        toast.error("Please enter the card holder's full name.");
                        ok.card.name = false;
                    } else ok.card.name = true;

                    if (!ok.all) {
                        toast.error("Please correct the issues below.");
                        return setTimeout(() => this.setState({
                            cardCheck: ok.card,
                            verifying: false
                        }), 100);
                    }

                    const added = await this.props.addPaymentMethod(this.state.card, this.state.details);
                    setTimeout(() => this.setState({ verifying: false }), 200);

                    if (added)
                        this.props.modal();
                }}
            >Confirm Credit/Debit Card</div>}
            
        </div>);
    }

};